import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Brunei: Country = {
    identifier: "Brunei",
    name: "Brunei",
    countryCode: "BN",
    group: CountryGroup.ASIA,
    isUNMember: true,
    flag: "🇧🇳",
    svgPath: "m 797.71675,449.2464 -0.229,0.122 -0.226,0.152 -0.226,0.131 -0.105,0.103 0.037,0.144 0.055,0.317 0.03,0.249 0.079,0.099 0.062,0.099 -0.025,0.108 -0.134,0.206 0.076,0.04 -0.097,0.273 -0.144,0.202 -0.199,0.165 -0.128,0.038 -0.103,-0.07 -0.168,-0.181 -0.183,-0.251 -0.085,-0.146 -0.263,-0.02 -0.094,-0.116 -0.006,-0.142 -0.074,-0.166 -0.104,-0.178 -0.154,-0.138 -0.207,-0.107 -0.088,-0.077 0.32,0.005 0.341,-0.045 0.351,-0.149 0.338,-0.18 0.284,-0.206 0.267,-0.232 0.279,-0.183 0.435,-0.213 0.146,0.017 -0.001,0.151 -0.057,0.179 z m 0,0 0.318,0 0.079,0.092 0.167,0.325 0.109,0.326 0.035,0.497 0.133,0.211 -0.021,0.043 -0.08,0.036 -0.124,0.015 -0.214,-0.048 -0.178,-0.073 -0.156,-0.538 -0.069,-0.304 0.006,-0.363 -0.005,-0.219 z",
}
